/**
 * Debug opt-in para eventos WebSocket del inbox.
 *
 * En producción, en la consola del navegador:
 *   window.__MERCATELY_INBOX_SOCKET_DEBUG__ = true
 * Para desactivar:
 *   window.__MERCATELY_INBOX_SOCKET_DEBUG__ = false
 */
export const INBOX_SOCKET_DEBUG_GLOBAL_KEY = '__MERCATELY_INBOX_SOCKET_DEBUG__';

export function isInboxSocketDebugEnabled() {
  if (typeof window !== 'undefined' && window[INBOX_SOCKET_DEBUG_GLOBAL_KEY] === true) {
    return true;
  }

  return process.env.NODE_ENV === 'development';
}
